import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Models
import { Purchase2 } from 'src/app/models/purchase2';

// Services
import { HttpService } from 'src/app/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class MenuStoreService {

  // Objetos Observable y Emiters
  private purchaseSubjet$ = new Subject<Purchase2>();

  constructor(
    private _httpService: HttpService
  ) { }

  emmiterPurchase(purchase: Purchase2): void {
    this.purchaseSubjet$.next(purchase);
  }

  getSubjetPurchase(): Subject<Purchase2> {
    return this.purchaseSubjet$;
  }

  getUrlPayment(data ?: any) {
    let clientId = localStorage.getItem('clientId');
    let modality = localStorage.getItem('modality');
    let table = localStorage.getItem('table_user');
    let headers = {
      'clientId': clientId,
      'modality': modality,
      'tableNumber': table
    }
    if(data == undefined || data == null) data = {};
    return this._httpService.httpPut(`compras/compra/pago`, data, headers);
  }


}
